import { ArrowRight } from "lucide-react"
import clsx from "clsx"

export function ArrowButton({ text = "Button", onClick, className, textClassName='', arrowClassName='' }) {
  return (
    <div
      className={clsx("flex items-center justify-center group bg-blue-600 text-white hover:bg-[#297fff] font-semibold transition-colors duration-200 cursor-pointer font-titillium", className)}
      onClick={onClick}
    > 
      <div className="flex items-center justify-center">  
        <div className={`mr-[28px] ${textClassName}`}>{text}</div>
        <ArrowRight className={`w-[26px] h-[26px] transition-transform duration-300 group-hover:translate-x-2 ${arrowClassName}`} />
      </div>
    </div>
  )
}